import React from "react";
import { PaymentHubAPI } from "../../../providers/PaymentHubAPI";
import { Button } from "../../components/Button";
import { Drawer } from "../../components/Drawer";
import { Input } from "../../components/Input";
import { Loading } from "../../components/Loading";
import { Select } from "../../components/Select";
import { Toggle } from "../../components/Toggle";
import { EnvironmentStorage } from "../../tools/EnvironmentStorage";

import { EnvironmentsAPI } from "@providers/EnvironmentsAPI";
import { Checkbox } from "../../components/Checkbox";
import styles from "@styles/integrations.module.scss";
import { Context } from "pages/Integrations";

export class ClearSaleDrawer extends React.Component {
  state = {
    loading: false,
    savingOptions: false,
    active: false,
    environmentType: "PRODUCTION",
    appId: null,
    username: null,
    password: null,
  };

  async setAsyncState(data) {
    return new Promise((resolve) => this.setState(data, resolve));
  }

  async componentDidMount() {
    try {
      await this.setAsyncState({ loading: true });
      const selectedEnvironment =
        await EnvironmentStorage.getSelectedEnvironment();
      await PaymentHubAPI.initAccount();

      const clearSaleGateway = await PaymentHubAPI.getGatewayConfiguration(
        selectedEnvironment,
        `clearsale`
      );

      this.setState({
        active: clearSaleGateway?.active || false,
        environmentType: clearSaleGateway?.environmentType || "PRODUCTION",
        appId: clearSaleGateway?.appId,
        username: clearSaleGateway?.username,
        password: clearSaleGateway?.password,
      });

      await this.setAsyncState({ loading: false });
    } catch (err) {
      await this.setAsyncState({ loading: false });
    }
  }

  async onSave() {
    try {
      const { onSave } = this.props;
      const {
        active,
        environmentType,
        appId,
        username,
        password,
      } = this.state;

      await this.setAsyncState({ savingOptions: true });

      const selectedEnvironment =
        await EnvironmentStorage.getSelectedEnvironment();
      const body = {
        active,
        environmentType,
        appId,
        username,
        password,
      };

      const paymentHubResponse = await PaymentHubAPI.setGatewayConfiguration(
        selectedEnvironment,
        `clearsale`,
        body
      );

      if (paymentHubResponse.getErrors([]).length > 0) {
        await this.setAsyncState({ savingOptions: false });
        return alert({
          text: `Não foi possível salvar as credenciais: ${
            paymentHubResponse.getErrors()[0]
          }`,
        });
      }

      const externalCredentials =
        await EnvironmentsAPI.getConfigurationsByAlias(
          selectedEnvironment,
          "external_credentials"
        );
      const environmentConfigsResponse =
        await EnvironmentsAPI.putConfigurationsByAlias(
          selectedEnvironment,
          "external_credentials",
          {
            ...externalCredentials,
            clearsale: body,
          }
        );

      if (environmentConfigsResponse.getErrors([]).length > 0) {
        await this.setAsyncState({ savingOptions: false });
        return alert({
          text: `Não foi possível salvar as credenciais: ${
            environmentConfigsResponse.getErrors()[0]
          }`,
        });
      }

      await this.setAsyncState({ savingOptions: false });
      onSave && onSave();
    } catch (e) {
      await this.setAsyncState({ savingOptions: false });
    }
  }

  render() {
    const { visible, onClose } = this.props;
    const {
      active,
      environmentType,
      appId,
      username,
      password,
      savingOptions,
      loading,
    } = this.state;

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        closeInFade
        title={"Integração - ClearSale"}
        footer={
          <Button
            design="primary"
            className="w-100"
            onClick={this.onSave.bind(this)}
            loading={savingOptions}
            disabled={loading || savingOptions}
          >
            Salvar alterações
          </Button>
        }
      >
        <Context />

        {loading ? (
          <div className="d-flex justify-center align-center h-100">
              <Loading fullScreen />
          </div>
        ) : (
          <div className={styles.scrollContainer}>
            <div className={styles.toggle}>
              <div className="d-flex justify-end w-100">
                <Toggle
                  active={active}
                  onChange={(active) => this.setState({ active })}
                />
              </div>
            </div>

            <Select
              design="two"
              label="Ambiente"
              onChange={(e) =>
                this.setState({ environmentType: e.target.value })
              }
              className="mb-20"
              value={environmentType}
              options={[
                {
                  label: "Produção",
                  value: "PRODUCTION",
                  selected: environmentType === "PRODUCTION",
                },
                {
                  label: "Homologação",
                  value: "SANDBOX",
                  selected: environmentType === "SANDBOX",
                },
              ]}
            />
            <Input
              design="two"
              className="mb-20"
              floatLabel="Id aplicativo ClearSale"
              value={appId}
              onChange={(e) => this.setState({ appId: e.target.value })}
            />
            <Input
              design="two"
              className="mb-20"
              floatLabel="Usuário"
              value={username}
              onChange={(e) => this.setState({ username: e.target.value })}
            />

            <Input
              design="two"
              className="mb-20"
              floatLabel="Senha"
              value={password}
              onChange={(e) => this.setState({ password: e.target.value })}
            />

          </div>
        )}
      </Drawer>
    );
  }
}
